import React, { useRef, useState, useEffect } from 'react';
import { Tooltip, TableCell } from '@mui/material';

export const EllipsisWithTooltip = ({ children }) => {
    const textRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const el = textRef.current;
        if (el) {
            setIsOverflowing(el.scrollWidth > el.clientWidth);
        }
    }, [children]);

    return (
        <Tooltip title={isOverflowing ? children : ''}>
            <span
                ref={textRef}
                style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                    width: '100%',
                }}
            >
                {children}
            </span>
        </Tooltip>
    );
};
